import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { ColDef } from 'ag-grid-community';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CommonService } from '../../services/commonservice';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';


@Component({
  selector: 'multipleChoice',
  standalone: true,
  imports: [CommonModule, FormsModule, AccordionModule, ReactiveFormsModule, IsgGridComponent],
  providers: [CommonService],
  templateUrl: './page-multiple-choice.component.html',
  styleUrl: './page-multiple-choice.component.scss'
})
export class PageMultipleChoiceComponent extends BaseHttpReqRespService {
  public questionOptionId!: string;
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;
  @ViewChild('deleteOptionConfirmation') deleteOptionTemplate!: TemplateRef<any>;
  public questionOptionList: questionOptions[] = [];
  optionGridConfig: Partial<IsgGridConfig> = {
    height: '250px',
    pagination: false,
    rowDragManaged: true,
  };
  myAppUrl: any;
  public questionId!: number;
  public folderId!: number;
  public apiKey!: string;
  public trigger!: string;
  public folderName!: string;
  private hideFolderName: boolean = false;
  public mode!: string;
  MULTICHOICE_ENDPOINT = API_ENDPOINTS.MULTICHOICE;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  quesCategoryForm!: FormGroup;
  choiceForm!: FormGroup;
  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;
  private gridApi: any;
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;
  // Add state variables for accordion groups
  isQuestionTitleOpen: boolean = true;
  isOptionsConfigOpen: boolean = false;

  constructor(
    private _router: Router,
    public http: HttpClient,
    private modalService: NgbModal,
    @Inject('BASE_URL') baseUrl: string,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    @Inject('CONFIG_SETTINGS') configSettings: any
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.myAppUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
  }
  backUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.folderId == -1)
        this._router.navigate(['/question']);
      else
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }
  saveQuestion() {
    if (this.questionId == undefined) {
      this.questionId = 0;
    }
    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? "0");
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    const data = {
      description: this.choiceForm.controls.description.value,
      questionId: String(this.questionId ?? 0),
      type: "MultipleChoice",
      folderId: String(this.folderId),
      questionCategoryId: String(this.choiceForm.controls.questionCategoryId.value),
      shortName: this.choiceForm.controls.shortName.value,
      userId: String(userId ?? 0),
      width: 0
    };

    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.SAVE_QUESTION,
      data,
      httpOptions
    ).subscribe(result => {
      this.questionId = result;
      this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
      this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
      var location = window.location.pathname;
      if (location.includes("/client") == false) {
        if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
          this.mapQuestionsToSection(this.questionId, this.redirectedSurveyId, this.redirectedSectionId)
        }
      }
      else {
        if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
          this.mapQuestionsToSection(this.questionId, this.redirectedSurveyId, this.redirectedSectionId)
        }
      }
    });
  }

  ngOnInit() {
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    this.choiceForm = this.formBuilder.group({
      description: new FormControl('', Validators.required),
      questionOption: '',
      isTextboxRequired: false,
      evaluateAndExit: false,
      weightage: new FormControl(''),
      questionCategoryId: new FormControl(''),
      shortName: new FormControl(''),
      optionShortName: new FormControl(''),
      hoverText: new FormControl('')
    });
    this.questionId = +this.route.snapshot.queryParams["questionId"];
    this.folderId = this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];
    if (this.folderName != null || '') {
      this.hideFolderName = false;
    }
    else {

      this.hideFolderName = true;
    }
    if (this.questionId > 0) {
      this.mode = "Edit";
      this.getQuestion();
    }

    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  getQuestion() {
    let parameter = "?questionId=" + this.questionId;
    this.commonService.httpGet("", this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.QUESTIONS + parameter).subscribe(response => {
      this.choiceForm.patchValue({

        description: response.description,
        weightage: response.weightage,
        questionCategoryId: response.questionCategoryId,
        shortName: response.shortName,

      });
      this.questionOptionList = response.questionOptions;
    }, error => console.error(error));
  }
  addChoice() {
    if (this.questionOptionId == undefined) {
      this.questionOptionId = "0";
    }
    var existOption = this.questionOptionList.find(x => x.description == this.choiceForm.controls.questionOption.value && x.questionId == this.questionId);
    if (existOption == undefined) {
      this.addOption();
    }
    else {
      if (this.trigger == "Edit") {
        this.addOption();
        this.showMessage("Option Updated Exists");
      }
      else {
        this.showMessage("Option Already Exists");
      }
      this.messageTimeout();
    }
  }

  addOption() {
    if (this.questionOptionId == undefined) {
      this.questionOptionId = "0";
    }
    if (this.choiceForm.controls.description.value != '' && this.choiceForm.controls.questionOption.value != '' && this.choiceForm.controls.questionOption.value != undefined) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      const data = {
        option: this.choiceForm.controls.questionOption.value,
        questionId: String(this.questionId),
        questionOptionId: this.questionOptionId ?? "0",
        isTextBoxRequired: this.choiceForm.controls.isTextboxRequired.value,
        evaluateAndExit: this.choiceForm.controls.evaluateAndExit.value,
        weightage: String(this.choiceForm.controls.weightage.value),
        hoverText: String(this.choiceForm.controls.hoverText.value),
        optionShortName: String(this.choiceForm.controls.optionShortName.value)
      }

      this.commonService.httpPostWOHeader(
        this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.ADD_OPTION,
        data,
        httpOptions
      ).subscribe(result => {
        this.questionOptionList = result;
        this.questionId = this.questionOptionList[0].questionId;
        this.questionOptionId = "0";
        this.choiceForm.patchValue({
          questionOption: "",
          isTextboxRequired: false,
          evaluateAndExit: false,
          weightage: "",
          hoverText: "",
          optionShortName: ""
        });
      });
    }
  }
  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "block";

    }

    var message = document.getElementById('message');
    if (message) {
      message.innerText = params;

    }
  }
  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 1800);
  }
  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }

    var message = document.getElementById('message');
    if (message) {
      message.innerText = '';
    }
  }
  //columnDefs2: (ColDef<questionOptions, any> | ColGroupDef<questionOptions>)[] = [
  //  { headerName: 'QuestionOptionId', field: 'questionOptionId', hide: true },
  //  { headerName: 'Choice', field: 'description', width: 200, rowDrag: true, cellRenderer: (params) => this.editOptionCellRenderer(params), resizable: true },
  //  { headerName: 'Weightage', field: 'weightage', width: 100, resizable: true },
  //  { headerName: 'Short Name', field: 'optionShortName', width: 150, resizable: true },
  //  { headerName: 'Hover Text', field: 'hoverText', width: 250, autoHeight: true, cellStyle: { 'white-space': 'normal' }, cellRenderer: (params) => `<span class="cell-wrap-text" title="${params.value}">${params.value}</span>`, resizable: true },
  //  { headerName: 'Is textbox required?', field: 'isTextboxRequired', width: 150, cellRenderer: (params) => this.CheckboxCellRenderer(true, params), resizable: true },
  //  { headerName: 'Evaluate and exit', field: 'evaluateAndExit', width: 140, cellRenderer: (params) => this.CheckboxCellRenderer(false, params), resizable: true },
  //  { headerName: 'Delete', field: '', width: 90, cellRenderer: (params) => this.deleteOptionCellRenderer(params), resizable: true }
  //];

  columnDefs: ColDef[] = [
    { headerName: 'QuestionOptionId', field: 'questionOptionId', hide: true, sortable: true, filter: true },
    { headerName: 'Choice', field: 'description', resizable: true, filter: true, width: 340, rowDrag: true, cellRenderer: this.editOptionCellRenderer.bind(this) },
    { headerName: 'Weightage', field: 'weightage', sortable: true, filter: true, width: 250, resizable: true },
    { headerName: 'Short Name', field: 'optionShortName', width: 150, resizable: true },
    { headerName: 'Hover Text', field: 'hoverText', width: 250, autoHeight: true, cellStyle: { 'white-space': 'normal' }, cellRenderer: (params: any) => `<span class="cell-wrap-text" title="${params.value}">${params.value}</span>`, resizable: true },
    { headerName: 'Is textbox required?', field: 'isTextboxRequired', width: 150, cellRenderer: (params: any) => this.CheckboxCellRenderer(true, params), resizable: true },
    { headerName: 'Evaluate and exit', field: 'evaluateAndExit', width: 140, cellRenderer: (params: any) => this.CheckboxCellRenderer(false, params), resizable: true },
    { headerName: 'Delete', field: '', width: 90, cellRenderer: (params: any) => this.deleteOptionCellRenderer(params), resizable: true }
  ];

  arrangeOrder() {
    var optionIdList = '';
    this.gridApi.forEachNode(function (rowNode: any) {
      optionIdList = optionIdList + rowNode.data.questionOptionId + ',';
    });
    const data = {
      questionId: this.questionId?.toString() ?? "0",
      optionIdList: optionIdList
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.ARRANGE_QUESTION_OPTION,
      data,
      httpOptions
    ).subscribe(result => {
      this.questionOptionList = result.questionOptions;
    }, error => console.error(error));
  }

  editOptionCellRenderer(params: any) {
    this.trigger = "Edit";
    const element = this.renderer.createElement('a');
    const attr = this.renderer.createText(params.data.description);
    this.renderer.appendChild(element, attr);
    this.renderer.setAttribute(element, 'href', 'javascript:void(0);');
    this.renderer.listen(element, 'click', () => {
      this.questionOptionId = params.data.questionOptionId;
      this.choiceForm.patchValue({
        questionOption: params.data.description,
        isTextboxRequired: params.data.isTextboxRequired,
        evaluateAndExit: params.data.evaluateAndExit,
        weightage: params.data.weightage === null ? '' : params.data.weightage,
        hoverText: params.data.hoverText,
        optionShortName: params.data.optionShortName
      });

    });
    return element;
  }
  CheckboxCellRenderer(isTextBox: any, params: any) {
    const elementI = this.renderer.createElement('i');
    var tmpvalue = false;
    if (isTextBox) {
      tmpvalue = params.data.isTextboxRequired;
    }
    else {
      tmpvalue = params.data.evaluateAndExit;

    }
    if (tmpvalue == true) {
      elementI.setAttribute('class', 'fa fa-check');
    }
    else {
      elementI.setAttribute('class', 'fa fa-close');
    }
    return elementI;
  }
  deleteOptionCellRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    element.setAttribute('href', 'javascript:void(0);');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.listen(element, 'click', () => {
      this.questionOptionId = params.data.questionOptionId;
      this.openDeleteOptionModal();
    });
    return element;
  }
  openDeleteOptionModal() {
    this.modalService.open(this.deleteOptionTemplate);
  }
  onQuestionGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }
  deleteOptions() {
    let data = {
      questionId: this.questionId?.toString() ?? "0", // ensure string
      questionOptionId: this.questionOptionId?.toString() ?? "0"
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + '/' + this.MULTICHOICE_ENDPOINT.REMOVE_OPTION, data, httpOptions
    ).subscribe(data => {
      this.questionOptionList = data;
      this.questionOptionId = '';
      // Refresh the grid
      if (this.gridApi) {
        this.gridApi.setRowData(this.questionOptionList);
      }
    });    
  }
  public resetQuestion() {
    this.choiceForm.controls.description.setValue("");
  }
  public resetForm() {
    this.questionOptionId = "0";
    this.choiceForm.controls.questionOption.setValue("");
    this.choiceForm.controls.isTextboxRequired.setValue(false);
    this.choiceForm.controls.evaluateAndExit.setValue(false);
    this.choiceForm.controls.weightage.setValue("");
    this.choiceForm.controls.hoverText.setValue("");
    this.choiceForm.controls.optionShortName.setValue("");

  }

  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + '/' + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
      }, 1200);
    }, error => console.error(error));

  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
  backToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }
}
interface questionOptions {
  questionId: number;
  questionOptionId: number;
  description: string;
  displayOrder: number;
  weightage: string;
  optionShortName: string;
  hoverText: string;

}
interface choices {
  questionOption: string;
  description: string;
  isTextboxRequired: boolean;
  evaluateAndExit: boolean;

}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}

